import { ApolloLink } from './ApolloLink';
export var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map